import { render, staticRenderFns } from "./TableRuleData.vue?vue&type=template&id=25c94906&scoped=true"
import script from "./TableRuleData.vue?vue&type=script&lang=js"
export * from "./TableRuleData.vue?vue&type=script&lang=js"
import style0 from "./TableRuleData.vue?vue&type=style&index=0&id=25c94906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c94906",
  null
  
)

export default component.exports